import { add } from './add';
import { findAll } from './findAll';
import { findOne } from './findOne';
import { findItunes } from './findItunes';
import { importFromItunes } from './importFromItunes';
import { importTrackFromItunes } from './importTrackFromItunes';
import { remove } from './remove';
import { search } from './search';
import { searchItunes } from './searchItunes';
import { update } from './update';

export const libraryAPI = {
  add,
  findAll,
  findOne,
  findItunes,
  importFromItunes,
  importTrackFromItunes,
  remove,
  search,
  searchItunes,
  update,
};
